export const largestCostSortByCountValues = [6, 8, 10, 12, 14];

export const largestCostChangeWidgetSortByValues = new Map([
  ["sort_by_percentage", "Percentage"],
  ["sort_by_amount", "Cost Amount"],
]);
